import React, { useEffect } from 'react';
import styled from 'styled-components';
import { PrimaryButton } from '../../CommonComponents/Button';
import Icon from '../../CommonComponents/Icon';
import Modal from '../../CommonComponents/Modal';
import useApi from '../../_hooks/useApi';
import getImagePath from '../../CommonUtils/getImagePath';

const StyledModal = styled(Modal)`
  &__content {
    padding: 100px;
    text-align: center;
    max-width: 670px;
    width: 100%;
    box-sizing: border-box;
  }
`;

const Title = styled.div`
  font-weight: 600;
  font-size: 24px;
  color: #6c727f;
  margin-bottom: 24px;
`;

const Subtitle = styled.div`
  font-size: 16px;
  margin-bottom: 48px;
  color: #444444;
`;

const OfflineImage = styled.img`
  width: 170px;
  display: block;
  margin: 0 auto 48px auto;
  color: #9c9c9c;
`;

interface Props {
  isOpen: boolean;
  onRequestClose: () => void;
  clientName: string;
  clientId: number;
}

export const ClientOfflineModal: React.FC<Props> = ({
  isOpen,
  onRequestClose,
  clientName,
  clientId,
}) => {
  const [
    requestCoBrowsingSession,
    { errors: requestCoBrowsingErrors, loading: requestCoBrowsingLoading },
  ] = useApi(`/Adviser/Glia/RequestCoBrowsingSession?clientId=${clientId}`);

  const [checkOnlineStatus, { errors: isOnlineErrors, loading: isOnlineLoading }] = useApi(
    `/Adviser/Glia/OnlineStatus?clientId=${clientId}`,
  );

  useEffect(() => {
    checkOnlineStatus({
      onSuccess({ isOnline }) {
        if (isOnline) {
          requestCoBrowsingSession({
            onSuccess({ cobrowsingUrl }) {
              window.open(cobrowsingUrl, '_blank');

              onRequestClose();
            },
          });
        }
      },
    });
  }, []);

  return (
    <StyledModal isOpen={isOpen} onRequestClose={onRequestClose} showCloseModalCross>
      {isOnlineLoading || requestCoBrowsingLoading ? (
        <Icon className="fas fa-circle-notch fa-spin" size="large" />
      ) : (
        <>
          {[...requestCoBrowsingErrors, ...isOnlineErrors].length > 0 ? (
            <>
              <Title>There was a problem starting the session</Title>

              {[...requestCoBrowsingErrors, ...isOnlineErrors].map(error => (
                <Subtitle>{error}</Subtitle>
              ))}

              <OfflineImage src={getImagePath('cobrowse-error.svg')} />

              <PrimaryButton onClick={onRequestClose}>Close</PrimaryButton>
            </>
          ) : (
            <>
              <Title>{clientName} is currently offline</Title>

              <Subtitle>Please check again later.</Subtitle>

              <OfflineImage src={getImagePath('cobrowse-error.svg')} />

              <PrimaryButton onClick={onRequestClose}>Close</PrimaryButton>
            </>
          )}
        </>
      )}
    </StyledModal>
  );
};
